export default __webpack_public_path__ + "static/media/Message.3c55178d.png";